<span [ngSwitch]="status">
  <span class="badge bg-secondary text-light" *ngSwitchCase="'OPEN'">Ouverte</span>
  <span class="badge bg-success text-light" *ngSwitchCase="'CONFIRMED'">Confirmée</span>
</span>